import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment'
import { unregister } from './registerServiceWorker'
import './index.scss'
import * as Promise from 'bluebird'

// react-at-rest 2.x still reads this API removed in React 16.
React.PropTypes = PropTypes
moment.suppressDeprecationWarnings = true

const { Store, RestForm, DeliveryService } = require('react-at-rest')
const App = require('./App').default

// use bluebird instead of native Promises
window.Promise = Promise

Store.API_PATH_PREFIX = '/api'
Store.API_ENVELOPE = false
Store.SUPERAGENT_PLUGINS = [(request) => {
  request.set('X-Source', 'Web')
  if (window.localStorage.accessToken) {
    request.set('Authorization', `Bearer ${window.localStorage.accessToken}`)
  }
}]

RestForm.prototype.parseErrors = (body) => {
  const errors = {}
  if (!_.isArray(body.errors)) return body

  body.errors.map((error) => {
    errors[error.path] = [error.message.replace('cannot be null', 'can\'t be left blank.')]
    return errors
  })

  return {
    errorMessage: body.message,
    errors: errors
  }
}

DeliveryService.prototype.reloadResources = function (props = this.props) {
  this.boundResources = []
  this.bindResources(props)
  this.getResources()
}

// react-at-rest 2.x only rebinds on react-router v3 props (props.params), so with
// react-router v4 a page stays on stale data when the route's *Id param changes
// while the component stays mounted (e.g. /dealerships/1 -> /dealerships/2 via back/forward).
DeliveryService.prototype.componentDidUpdate = function (prevProps) {
  const params = _.get(this.props, 'match.params') || {}
  const prevParams = _.get(prevProps, 'match.params') || {}
  const idChanged = Object.keys({ ...params, ...prevParams })
    .some(key => key.slice(-2) === 'Id' && params[key] !== prevParams[key])
  if (!idChanged) return

  this.setState({ loaded: false })
  this.reloadResources(this.props)
}

ReactDOM.render(<App />, document.getElementById('root'))

unregister()
